<template>
  <div>
    <div class="title-wrap">
      <span class="title">友情链接</span>
    </div>
    <ul class="link-wrap">
      <!-- <li class="content-wrap"><a target="_blank" href="https://service.zjrc.com/">浙江省人才服务平台</a></li> -->
      <li class="content-wrap"><a target="_blank" href="http://web.nbdj.gov.cn/">宁波党建</a></li>
      <li class="content-wrap"><a target="_blank" href="https://ycyg.nbhr.org.cn/">宁波市人力资源综合服务平台</a></li>
      <li class="content-wrap"><a target="_blank" href="https://www.nbrc.com.cn/">宁波人才网</a></li>
      <li class="content-wrap"><a target="_blank" href="https://hrs.nbrc.com.cn/">宁波市人才服务申报系统</a></li>
      <li class="content-wrap"><a target="_blank" href="http://www.nbrcg.com/">宁波人才发展集团</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OutLink',
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
